module.exports = __webpack_public_path__ + "static/media/Profile.91942cea.svg";